/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { AdminGetThermostatControlMeasurementsPathParameters } from 'api/actions/admin-get-thermostat-control-measurements/admin-get-thermostat-control-measurements-path-parameters';
import { AdminGetThermostatControlMeasurementsResponse } from 'api/actions/admin-get-thermostat-control-measurements/admin-get-thermostat-control-measurements-response';

type AdminGetThermostatControlMeasurementsQueryParameters = Record<string, any>;

/**
 * The path of the AdminGetThermostatControlMeasurements action.
 */
export const adminGetThermostatControlMeasurementsActionPath = new SweetPath<
  keyof AdminGetThermostatControlMeasurementsPathParameters
>('/admin/custom/thermostat-control/{deviceId}/measurements', { path: '{param}' });

/**
 * Creates a contextualized AdminGetThermostatControlMeasurements actions.
 */
export default function createAdminGetThermostatControlMeasurementsAction(axios: AxiosInstance) {
  return function adminGetThermostatControlMeasurementsAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: AdminGetThermostatControlMeasurementsPathParameters;
    query?: AdminGetThermostatControlMeasurementsQueryParameters;
  }) {
    const path = adminGetThermostatControlMeasurementsActionPath.insert(parameters);

    return axios.get<AdminGetThermostatControlMeasurementsResponse, AdminGetThermostatControlMeasurementsResponse>(
      path,
      { params: query, headers }
    );
  };
}
